<p-panel class="mb-4" header="User Account Information" toggler="header" [toggleable]="true" iconPos="start">
  <ng-template #headericons let-collapsed>
    <i class="pi pi-chevron-right duration-150" [class]="{ 'rotate-90': !collapsed }"></i>
  </ng-template>

  @if (isLoading) {
    <div class="flex justify-center">
      @if (isLoading) {
        <p-progressSpinner class="w-8 h-8" />
      }
    </div>
  }
  @if (disableRadioButtons) {
    <div class="mb-4">
      <div class="flex gap-4">
        <p class="font-semibold">Health Plan:</p>
        <span>Regence</span>
      </div>
    </div>
  }
  @if (!isLoading) {
    <div class="mb-4">
      @if (!disableRadioButtons && !removeAccountType) {
        <div class="flex gap-4 items-center mb-4">
          <label class="font-semibold" for="selecthp">Health Plan:</label>
          <div>
            @if (!removeCHAPPAccountType) {
              <p-select
                [options]="applicableHealthPlans"
                [(ngModel)]="healthPlan"
                (onChange)="onChangeHealthPlan($event.value)"
                placeholder="Select Item"
                appendTo="body"
                inputId="selecthp"
              />
            } @else {
              <p>Anthem</p>
            }
          </div>
        </div>
      }

      <app-account-switch
        [accountTypes]="applicableAccountTypes"
        [account]="accountType"
        [hasSelectedProviders]="hasSelectedProviders"
        [userId]="userId"
        [healthPlan]="healthPlan"
        [tenantId]="healthPlan?.tenantId"
        (accountTypeNew)="onChangeAccountType($event)"
        (showCentralizedDepartmentToggleForHP)="showCentralizedDepartmentToggleForHP = $event"
        [disableRadioButtons]="disableRadioButtons"
        [removeCHAPPAccountType]="removeCHAPPAccountType"
      />
    </div>
  }

  @if (shouldShowCentralizedDepartmentToggle && showCentralizedDepartmentToggleForHP) {
    <app-centralized-department-toggle
      [userId]="userId"
      [currentCompany]="centralizedDepartment"
      [accountType]="accountType"
    />
  }

  @if (showAssignProvidersWidget) {
    <div class="mt-4">
      <app-assign-providers-to-user
        [tenantId]="healthPlan?.tenantId"
        [userId]="userId"
        [accountType]="accountType"
        (selectedProviders)="onSelectProvider($event)"
        (userProvidersChanged)="onUserProvidersChanged()"
      />
    </div>
  }
</p-panel>
